import { define, html, store } from "hybrids";

import layout from "~/factories/layout";
import Broadcast from "~/stores/Broadcast";

export interface VBroadcastShareView {
  broadcast?: Broadcast;
}

export default define<VBroadcastShareView>({
  tag: "v-broadcast-share-view",
  broadcast: store(Broadcast),
  render: layout("flex"),
  content: ({ broadcast }) => html`
    ${broadcast &&
    store.ready(broadcast) &&
    html`
      <v-broadcast-container grow overflow>
        <v-broadcast-nav-bar close>Share</v-broadcast-nav-bar>
        <v-broadcast-share
          url="${broadcast.course.shareUrl}"
          name="${broadcast.course.name}"
        ></v-broadcast-share>
      </v-broadcast-container>
    `}
  `,
});
